import {
  AuthService,
  GetSsoConnectionResponse,
  VerifyAuthResponse,
} from '@weave/schema-gen-ts/dist/schemas/auth-api/v3/auth.pb';
import { resetPassword } from '@frontend/api-users';
import { authnClient } from '@frontend/auth';
import { baseFetch } from './fetch-wrapper';

export const sendPasswordReset = async (username: string): Promise<void> => {
  return resetPassword(username).then(() => {}); // ignore response, forward any errors
};

export const signInWithPassword = async (
  username: string,
  password: string,
  registerWebauthn = false
): Promise<VerifyAuthResponse> => {
  authnClient.changeAuthMethod('legacy');
  return authnClient.signIn({ username, password, registerWebauthn });
};

export const getSsoConnection = async (tenant: string): Promise<{ clientId: string; redirectUri: string }> => {
  if (tenant === '') {
    throw new Error('ssoTenantNotFound');
  }

  const res = await AuthService.GetSsoConnection(baseFetch<GetSsoConnectionResponse>(), { tenant });
  if (!res.clientId || !res.redirectUri) {
    throw new Error('ssoTenantNotFound');
  }

  return { clientId: res.clientId, redirectUri: res.redirectUri };
};
